import React, {useState} from 'react';
import {connect} from 'react-redux';
import {deepClone, sortBy, startCase} from 'lodash';


// local imports
import api from '../../../store/api'
import {toggleGlobalLoader, addErrorAlert, addLoadingAlert, removeLoadingAlert} from "../../../store/calls/alertLoadingDispatch";
import validators from "../../../utils/forms/validators";

import AdminWrapper from "../../theme/wrappers/AdminWrapper";

import ApplicationBuilder from "../../subcomponents/admin/ApplicationBuilder";
import FormModal from "../../theme/modals/FormModal";



export default class ApplicationTemplateBuilderScreen extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            editingInstance: {
                id: props.match.params.id
            }
        }

        this.baseAPIPath = '/application-template/' + this.state.editingInstance.id + '/';

    }

    componentDidMount() {
        toggleGlobalLoader(true);

        Promise.all([
            this.getData(),
        ])
            .then(() => toggleGlobalLoader(false))
            .catch(() => {
                addErrorAlert('Failed to load all initial data.', 10 * 1000);
                toggleGlobalLoader(false);
            })

    }

    toggleEditModal = () => {
        this.setState({editModalOpen: !this.state.editModalOpen})
    }


    getData = (xtraParams = {}) => {
        return api.get(`/application-templates/${this.state.editingInstance.id}`, xtraParams)
            .then(res => {
                this.setState({editingInstance: res.data})
            })
    }

    onUpdateTemplate = (data) => {
        toggleGlobalLoader(true)
        return api.patch(`/application-templates/${this.state.editingInstance.id}/`, data)
            .then(res => this.setState({editingInstance: res.data}))
            .catch(() => addErrorAlert('There was a problem updating the object.'))
            .finally(() => toggleGlobalLoader(false))
    }


    render() {
        return (
            <AdminWrapper>
                <ApplicationBuilder
                    title={`Edit Template ${this.state.editingInstance?.name || ''}`}
                    onSave={this.onUpdateTemplate}
                    template={this.state.editingInstance?.template}
                    showMergeOptions
                    mergeIntoObject={this.state.editingInstance}
                    isGlobalTemplate
                >
                    {/* CHILDREN ARE USED AS HEADER */}
                    <div className="p-4 pb-0">
                        <h3 className="title pb-2 m-0 is-size-3 has-text-primary">Edit Template</h3>
                        {!!this.state.editingInstance?.name &&
                            <div className="is-flex">
                                <h4 className="subtitle">{this.state.editingInstance.name}</h4>
                                <i
                                    onClick={() => { this.setState({displayEditNameModal: true})}}
                                    className="fas fa-edit ml-3 pt-1 has-text-primary cursor-is-pointer"
                                />
                            </div>
                        }
                    </div>

                </ApplicationBuilder>

                {this.state.displayEditNameModal &&
                    <FormModal
                        title="Edit Name"
                        visible
                        inputs={[
                            {
                                type: 'text',
                                label: "Name",
                                dataKey: "name",
                                value: this.state.editingInstance?.name,
                                ...validators.isStringOfMinLength(2)
                            },
                        ]}
                        disableAutocomplete
                        onSubmit={data => {
                            return Promise.resolve(this.onUpdateTemplate(data))
                                .then(() => this.setState({displayEditNameModal: false}))
                        }}
                        onCancel={() => this.setState({displayEditNameModal: false})}
                    />
                }

            </AdminWrapper>
        )
    }

}

